import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AppProviders } from "./AppProviders";
import { useAuth } from "./data/providers/AuthProvider";
import { UserDataProvider } from "./data/providers/UserDataProvider";
import AllApplicationsPage from "./pages/AllApplicationsPage";
import AllProfilePage from "./pages/AllProfilePage";
import AnalyticsPage from "./pages/AnalyticsPage";
import ApplicationsPage from "./pages/ApplicationsPage";
import Dashboard from "./pages/Dashboard";
import DataProcessingPolicyPage from "./pages/DataProcessingPolicyPage";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProfilePage from "./pages/ProfilePage";
import PrivateRoute from "./routes/PrivateRoute";
import { RequireRole } from "./routes/RequireRole";
import RoleSwitch from "./routes/RoleSwitch";
import darkTheme from "./theme";

const App: React.FC = () => {
  const { loading } = useAuth();

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {loading ? (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f6fa",
          }}
        >
          <CircularProgress size={48} color="primary" />
        </Box>
      ) : (
        <AppProviders>
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/privacidad" element={<PrivacyPolicyPage />} />
              <Route
                path="/tratamiento-datos"
                element={<DataProcessingPolicyPage />}
              />
              <Route element={<PrivateRoute />}>
                <Route
                  path="/dashboard"
                  element={
                    <UserDataProvider>
                      <Dashboard />
                    </UserDataProvider>
                  }
                >
                  <Route index element={<RoleSwitch />} />

                  <Route element={<RequireRole roles={["USER"]} />}>
                    <Route path="applications" element={<ApplicationsPage />} />
                    <Route path="profile" element={<ProfilePage />} />
                  </Route>

                  <Route element={<RequireRole roles={["ADM"]} />}>
                    <Route path="analytics" element={<AnalyticsPage />} />
                    <Route
                      path="all-applications"
                      element={<AllApplicationsPage />}
                    />
                    <Route path="all-profile" element={<AllProfilePage />} />
                  </Route>

                  <Route
                    path="unauthorized"
                    element={<div>403 - Sin permisos</div>}
                  />
                </Route>
              </Route>
              <Route
                path="*"
                element={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                      textAlign: "center",
                    }}
                  >
                    <h1>404 - Página no encontrada</h1>
                    <p>La ruta a la que intentaste acceder no existe.</p>
                    <a
                      href="/"
                      style={{
                        marginTop: "1rem",
                        padding: "0.5rem 1rem",
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        borderRadius: "5px",
                        textDecoration: "none",
                      }}
                    >
                      Ir al inicio
                    </a>
                  </div>
                }
              />
            </Routes>
          </Router>
        </AppProviders>
      )}
    </ThemeProvider>
  );
};

export default App;
